import { Resource } from "./Resource";

/**
 * The XmlResource is used for holding xmls from preloading.
 * @class XmlResource
 * @extends Resource
 */
export class XmlResource extends Resource {
    static Root: string = "Elements";

    private static items: Array<XMLDocument> = [];

    public static get Items(): Array<XMLDocument> {
        return XmlResource.items;
    }

    public static add(doc: XMLDocument): void {
        XmlResource.items.push(doc);
    }

    public static cleanup(): void {
        if (XmlResource.items) {
            XmlResource.items.length = 0;
            XmlResource.items = null;
        }
    }

    public static emptyItems(): void {
        if (XmlResource.items) {
            XmlResource.items = [];
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Resources/XmlResource.ts
 **/